module.exports = __webpack_public_path__ + "img/japanese.7196146d.png";